module.exports = __webpack_public_path__ + "static/media/brutal_bracelets.37da557c.png";